exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "td.precondition-details {\n  word-break: break-all;\n}\nth.precondition-details {\n  width: 70%;\n}\n", ""]);

